export default __webpack_public_path__ + "static/media/mui.5b2d8a0a.png";